import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}

import { computed, toRef } from 'vue'
    import type { ProjectProposalLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectProposalLifecycleSetter"

    // props
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectProposalLifecycleSetter',
  props: {
    viewModel: {}
  },
  emits: ["confirm"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    // emits
    const emit = __emit

    // vm shortcut
    const vm = toRef(props, 'viewModel')

    // state
    const opened = computed(() => vm.value?.opened ?? false)

    // actions
    function confirm()
    {
        emit('confirm', vm.value.projectId)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", { class: "modal-wrapper" }, [
          _createElementVNode("div", { class: "modal-dialog modal-dialog-scrollable" }, [
            _createElementVNode("div", { class: "modal-content" }, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Revert Project Lifecycle to Proposal", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-body" }, [
                _createElementVNode("p", null, [
                  _createTextVNode(" You are about to set the project lifecycle back to the "),
                  _createElementVNode("strong", null, "Proposal"),
                  _createTextVNode(" stage. ")
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "button",
                  onClick: confirm,
                  class: "btn btn-primary"
                }, "Confirm")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})